import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './index.css';
import Navbar from './components/Navbar';
import Introduction from './components/Introduction';
import Experience from './components/Experience';
import FullJourney from './components/FullJourney'; 
import Capabilities from './components/Capabilities';
import Career from './components/Career';
import CareerEnd from './components/CareerEnd';
import Projects from './components/Projects';

import reportWebVitals from './reportWebVitals';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <Introduction />
              <Experience />
              <Capabilities />
              <Career />
              <Projects />
              <CareerEnd showReviewButton={true} />
              <Footer />
            </>
          }
        />

        <Route
          path="/full-journey"
          element={
            <>
              <FullJourney />
              <CareerEnd showReviewButton={false} />
              <Footer />
            </>
          }
        />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
